import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import LoanSimulationService from '../../services/LoanSimulation';
import { LoanSimulation } from '../../interfaces/LoanSimulation';
import { useLocation, useNavigate } from 'react-router-dom';
import { MERCHANTS, ROUTES_PATH, VALIDATOR_PATTERN } from '../../constants';
import { useLoanSimulation } from '../../contexts/LoanSimulationContext';
import MerchantService from './../../services/Merchant/index';
import { GoodTypes } from '../../interfaces/MerchantInfo';
import { useProduct } from './../../contexts/ProductContext/product-context.hook';
import entryShop from '../../assets/images/entry/EntryShop.svg';
import editIcon from '../../assets/images/entry/EditIcon.svg';
import creditCard from '../../assets/images/entry/CreditCard.svg';
import bankCard from '../../assets/images/entry/BankCard.svg';
import arrowIcon from '../../assets/images/entry/Arrow.svg';
import {
  EntryForm,
  TodayHighlight,
  TodayHighlightText,
  FirstFeeText,
  FirstFee,
  RegularFeeText,
  DetailsSectionSubtitle,
  WrapperBox,
  WrapperBoxElement,
  WrapperBoxSection,
  ProdTitle,
  ImageEntry,
  OfferSelectorWrapper,
  EditIcon,
  ImageIconBank,
  SummaryWrapper,
  SummaryData,
  RateListWrapper,
  RateData,
  RateIconWrapper,
  RateText,
  ArrowWrapper,
  ArrowImg,
  TextBoldSpan,
  DetailsInfo,
  DetailSpecialSection,
} from './StyledComponents';
import {
  FormInputRow,
  FormFloating,
  FormInput,
  FormOption,
  FormInputLabel,
  ValidationError,
} from '../../styles/FormStyledComponents';
import {
  EuroIcon,
  MainButton,
  MonthText,
  SeparationLine,
  TextMedium,
  TextRegular,
  Title,
} from '../../styles/GlobalStyledComponents';

import EuroImg from '../../assets/images/euro-icon.svg';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';
import InsightService from '../../services/Insight';
import { CommercialOfferType } from '../../services/LoanSimulation/types';
import dayjs from 'dayjs';
import { blockCharacters, transformAmount } from '../../utils/formInputHelper';
import { CommercialOffer } from '../../interfaces/CommercialOffer';
import { SimulationProductValue } from '../../interfaces/Simulation';
import {
  fetchCommercialOffersList,
  setCommercialOffersStored,
} from '../../utils/commercialOffersHelper';
import AnalyticsService from '../../services/Analytics';
import AnalyticsHelper from '../../utils/analyticsHelper';

let abortController = new AbortController();
interface LocationState {
  origin?: string;
}

export const Entry = () => {
  let navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const { origin } = (location.state as LocationState) || {};
  const { loanSimulation, createLoanSimulation } = useLoanSimulation();
  const { product, createProduct, amount } = useProduct();
  const { creditProposalResult } = useCreditProposalResult();

  const [term, setTerm] = useState(0);
  const [inputAmount, setInputAmount] = useState<string>('');
  const [simulationSelected, setSimulationSelected] =
    useState<LoanSimulation | null>(null);
  const [products, setProducts] = useState<GoodTypes[] | undefined>(undefined);
  const [productSelected, setProductSelected] = useState<GoodTypes | undefined>(
    undefined
  );
  const [amountError, setAmountError] = useState(false);
  const [startTransition, setStartTransition] = useState(false);
  const [commercialOffersList, setCommercialOffersList] = useState<
    CommercialOfferType[] | undefined
  >();
  const [commercialOffersFilteredList, setCommercialOffersFilteredList] =
    useState<CommercialOfferType[] | undefined>();
  const [commercialOfferSelected, setcommercialOfferSelected] = useState<
    CommercialOfferType | undefined
  >(undefined);
  const [shownCommercialOfferList, setShownComercialOfferList] =
    useState<CommercialOfferType[]>();
  const [showBtn, setShowBtn] = useState(false);
  const [showSummary, setShowSummary] = useState(origin === 'personalData');

  const [termList, settermList] = useState<number[]>([]);

  // const [simulationLoading, setSimulationLoading] = useState(false);

  const [termError, setTermError] = useState(false);
  // const [isTopScroll, setIsTopScroll] = useState(true);
  // const [isBottomScroll, setIsBottomScroll] = useState(true);

  const [topArrowDisabled, setTopArrowDisabled] = useState<boolean>(true);
  const [bottomArrowDisabled, setBottomArrowDisabled] = useState<boolean>(true);
  const [hideTermList, setHideTermList] = useState(true);
  const [isDecathlon, setIsDecathlon] = useState(false);
  const [storageOffers, setstorageOffers] = useState<CommercialOffer[]>();

  const [productValue, setProductValue] = useState<SimulationProductValue>();
  const [simulatedData, setSimulatedData] = useState<{
    term: number;
    amount: number;
  } | null>();

  // DORSIA
  const amountParam = sessionStorage.getItem('amount')
    ? JSON.parse(sessionStorage.getItem('amount')!)
    : null;
  const inputMode = sessionStorage.getItem('inputMode')
    ? JSON.parse(sessionStorage.getItem('inputMode')!)
    : null;

  const startTime = dayjs();

  useEffect(() => {
    if (inputAmount) {
      const data = setTimeout(() => {
        // if amount didn´t change
        if (amount?.toString() === inputAmount) {
          setHideTermList(false);
        } else {
          setInputAmount(inputAmount);
        }
      }, 1000);
      return () => clearTimeout(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputAmount]);

  useEffect(() => {
    if (inputAmount && parseFloat(inputAmount) > 0) {
      getNewSimulation(inputAmount);
    } else if (parseFloat(inputAmount) < 0 || inputAmount === '0') {
      setAmountError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputAmount]);

  const handleSelection = (commercialOffersL: CommercialOfferType[]) => {
    if (commercialOffersL && commercialOffersL.length > 0) {
      const filteredList: CommercialOfferType[] = [];
      const offersList = [...commercialOffersL];
      offersList?.forEach((elem) => {
        const filteredF = elem.financial_offers.filter((e) => e.term === term);
        const newElem = elem;
        newElem.financial_offers = filteredF;
        if (newElem.financial_offers.length > 0) {
          filteredList.push(newElem);
        }
      });
      setCommercialOffersFilteredList(filteredList);
      if (filteredList.length > 3) {
        let shownOffers = filteredList.slice(0, 3);
        setShownComercialOfferList(shownOffers);
        setBottomArrowDisabled(false);
      } else {
        setShownComercialOfferList(filteredList);
        setBottomArrowDisabled(true);
      }
      filteredList[0] && setcommercialOfferSelected(filteredList[0]);
      let selection;
      if (filteredList[0]) {
        selection = filteredList[0];
      }
      if (selection) {
        InsightService.logTrace('LoanSimulation', [
          { commercialOfferId: selection?.commercial_offer_id },
          { amount: selection.financial_offers[0].total_cost.toString() },
          { term: selection.financial_offers[0].term.toString() },
        ]);
        setSimulationSelected(selection.financial_offers[0]);
        // Guardamos la simulación sin confirmación del cliente aún
        createLoanSimulation(selection.financial_offers[0]);
        AnalyticsService.sendSimulation({
          simulation_amount: inputAmount ? parseFloat(inputAmount) : amount,
          simulation_max_term: termList[termList.length - 1],
          simulation_min_term: termList[0],
          simulation_term_count: termList.length,
          simulation_term: term,
          simulation_offer_count: selection.financial_offers.length,
          simulation_cex_available: filteredList.find(e => e.flow === 'CEX') ? true : false,
          simulation_sus_available: filteredList.find(e => e.flow === 'SUS') ? true : false,
          simulation_pls_available: filteredList.find(e => e.flow === 'PLS') ? true : false,
        })
      }
      if (!showBtn && !amountError) {
        setShowSummary(true);
      }
    }
  };

  const saveCommercialOffers = async () => {
    try {
      const totalOffers = await fetchCommercialOffersList();
      const merchantId = sessionStorage.getItem('merchantId');
      if (merchantId && totalOffers) {
        setCommercialOffersStored(totalOffers, merchantId);
      }
    } catch (error) {
      console.error('Error fetching commercial offers:', error);
    }
  };

  useEffect(() => {
    if (term) {
      getLoanSimulation();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term]);

  useEffect(() => {
    const offerS = localStorage.getItem('pepper-commercial-offers-S');
    if (offerS) {
      const parseOffers = JSON.parse(offerS);
      parseOffers.value && setstorageOffers(parseOffers.value);
    } else {
      saveCommercialOffers();
    }

    if (!simulationSelected) {
      setSimulationSelected(loanSimulation);
    }

    getProducts();

    //Se limpian los datos de navegación si proviene de la pantalla de datos personales
    if (origin && origin === 'personalData') {
      if (product && amount && loanSimulation?.term && !amountError) {
        setShowSummary(true);
        setSimulatedData(null);
      }
      navigate(location.pathname, { replace: true, state: {} });
    }

    if (creditProposalResult) {
      setInputAmount(JSON.stringify(creditProposalResult.requested_amount));
      creditProposalResult.term && setTerm(creditProposalResult.term);
    }
    const merchantId = sessionStorage.getItem('merchantId');

    if (merchantId) {
      setIsDecathlon(merchantId === MERCHANTS.DECATHLON);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    state && productValue && formSubmit(productValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productValue]);

  const getNewSimulation = async (amountSelected: string) => {
    try {
      setCommercialOffersList([]);
      setAmountError(false);
      setHideTermList(false);
      const amountT = parseFloat(amountSelected);
      let termsL: number[] = [];
      storageOffers?.forEach((e) => {
        if (e.max_amount >= amountT && e.min_amount <= amountT)
          termsL.push(e.term);
      });
      termsL.sort((a, b) => {
        return a - b;
      });
      termsL = [...new Set(termsL)];
      settermList(termsL);
      if (!termsL || termsL.length === 0) {
        setAmountError(true);
        setStartTransition(false);
      }
    } catch (error) {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  const getLoanSimulation = async () => {
    try {
      let amountT = inputAmount ? parseFloat(inputAmount) : amount || 0;
      if (amountT === 0) {
        setAmountError(true);
        setStartTransition(false);
      } else {
        setSimulatedData({ term: term, amount: amountT });
        const sim = {
          amount: amountT,
          flows: ['CEX', 'PLS', 'SUS', 'ECO'],
          term: term,
        };
        const commercialOffers = await LoanSimulationService.create(sim);
        setCommercialOffersList(commercialOffers.commercial_offers);
        handleSelection(commercialOffers.commercial_offers);
      }
    } catch (error) {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  const getMerchantData = async (): Promise<GoodTypes[] | undefined> => {
    try {
      const merchantD = sessionStorage.getItem('merchantGoodTypes');
      const merchantInfo = merchantD ? JSON.parse(merchantD) : undefined;
      if (merchantInfo && merchantInfo[0].code && merchantInfo[0].name) {
        return merchantInfo;
      } else {
        const response = await MerchantService.getMerchantInfo();
        return response.good_types;
      }
    } catch (error) {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  const getProducts = async () => {
    try {
      const goodTypes = await getMerchantData();
      if (goodTypes) {
        setProducts(goodTypes);
        if (origin !== 'personalData') {
          setProductSelected(goodTypes[0]);
          let amountSent;
          if (creditProposalResult && inputAmount === '') {
            amountSent = JSON.stringify(creditProposalResult.requested_amount);
            setAmountError(false);
          } else if (state) {
            amountSent = state.toString().replace(',', '.');
          } else {
            amountSent = '';
          }
          const initProductV = {
            product: creditProposalResult
              ? creditProposalResult.good_type
              : goodTypes[0].code,
            amount: amountSent,
            termNumber: '',
          };
          setProductValue(initProductV);
        } else {
          recoverProductSelected();
        }
      } else {
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    } catch (error: any) {
      if (error?.response?.status === 401) navigate(ROUTES_PATH.TIMEOUT);
      else navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };

  const saveProductSelected = (product: string) => {
    if (product) {
      const productType = products?.find(
        (pr: GoodTypes) => pr.code === product
      );
      setProductSelected(productType);
      createProduct(productType, parseFloat(inputAmount));
    }
  };

  const recoverProductSelected = () => {
    const productTypeSelected = product;
    const amountSelected = amount;
    const termSelected = loanSimulation?.term;

    const productObj: SimulationProductValue = {
      product: '',
      amount: '',
      termNumber: '',
    };

    //Recupera el tipo de producto, el importe y la cuota basado en la simulación previa
    if (productTypeSelected) {
      //Actualizamos el tipo de producto
      setProductSelected(productTypeSelected);
      productObj.product = productTypeSelected.code;
    }
    if (amountSelected) {
      setInputAmount(amountSelected.toString());
      productObj.amount = amountSelected.toString();
    }
    if (termSelected) {
      setTerm(termSelected);
      productObj.termNumber = termSelected.toString();
    }
    setProductValue(productObj);
  };

  const formSubmit = ({
    product,
    amount,
  }: {
    product: string;
    amount: string;
  }) => {
    if (origin !== 'personalData') {
      const selectedProduct = products?.find(
        (pr: GoodTypes) => pr.code === product
      );
      if (selectedProduct) {
        setProductSelected(selectedProduct);
        createProduct(selectedProduct, parseFloat(amount));
      }
      setInputAmount(amount);
      setAmountError(false);
    }
  };

  const handleContinue = () => {
    if (simulationSelected && productSelected) {
      simulationSelected.commercial_offer_id =
        commercialOfferSelected?.commercial_offer_id;
      simulationSelected.flow = commercialOfferSelected?.flow;
      simulationSelected.first_due_date =
        commercialOfferSelected?.first_due_date;
      createLoanSimulation(simulationSelected);
      createProduct(productSelected, parseFloat(inputAmount));
      AnalyticsService.continueEntry({
        simulation_amount: inputAmount ? parseFloat(inputAmount) : amount,
        simulation_term: simulationSelected.term,
        simulation_tae: simulationSelected.tae,
        simulation_tin: simulationSelected.tin,
        simulation_regular_fee: simulationSelected.regular_fee,
        simulation_first_fee: simulationSelected.first_fee,
        simulation_total_cost: simulationSelected.total_cost,
        simulation_opening_fee: simulationSelected.opening_fee,
        simulation_opening_fee_type: simulationSelected.opening_fee_type,
        simulation_flow_step: simulationSelected.flow,
        step_number: 1,
        time_elapsed: AnalyticsHelper.getTimeElapse({initTime: startTime, finishTime: dayjs()}),
      });
      AnalyticsService.beginTransaction({
        currency: 'EUR',
        value: inputAmount ? parseFloat(inputAmount) : amount,
        items: [
          {
            item_id: productSelected.code,
            item_name: productSelected.name,
          },
        ],
      })
      navigate(ROUTES_PATH.PERSONAL_DATA);
    }
  };

  const validateAmount = (value: number) => {
    let error;
    if (!value) {
      error = 'Introduce un importe válido';
      setStartTransition(false);
    }
    return error;
  };

  const handleAmountChange = () => {
    AnalyticsService.editSimulation();
    //setSimulationSelected(null);
    setShowSummary(false);
    setStartTransition(false);
    setShowBtn(true);
    //setInputAmount('');
    //setTerm(0);
    //setHideTermList(true);
    //setCommercialOffersList([]);
    //setCommercialOffersFilteredList([]);
    //document?.getElementById('entry-amount-input')?.focus();
    recoverProductSelected();
  };

  const handleAmountInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    handleChange: any
  ) => {
    let { value } = e.target;
    if (VALIDATOR_PATTERN.ENTRY_AMOUNT.test(value) || value === '') {
      if (value.includes(',') || value.includes('.')) {
        if (value.includes(',')) {
          value = value.replace(',', '.');
        }
        //Comprueba los decimales introducidos y limita a 2
        const decimals = value.split('.')[1];
        if (decimals.length <= 2) {
          setInputAmount(value);
          handleChange(e);
        }
      } else {
        setInputAmount(value);
        handleChange(e);
      }
    }
  };

  const handleTopArrow = () => {
    //true -> desactivar, false -> activar. Ejemplos: RED67674 / DNT60166. 8000 - 60 cuotas = 5 y 2000 - 30 cuotas = 3 y 2500 - 60 cuotas = 5
    if (
      commercialOffersFilteredList &&
      shownCommercialOfferList &&
      commercialOffersFilteredList.length > 3
    ) {
      let firstOfferIndex = commercialOffersFilteredList.indexOf(
        shownCommercialOfferList[0]
      );
      if (firstOfferIndex - 3 >= 0) {
        let shownOffers = commercialOffersFilteredList.slice(
          firstOfferIndex - 3,
          firstOfferIndex
        );
        firstOfferIndex -= 3;
        setShownComercialOfferList(shownOffers);
        if (bottomArrowDisabled) setBottomArrowDisabled(false);
        setTopArrowDisabled(false);
      } else {
        let shownOffers = commercialOffersFilteredList.slice(0, 3);
        setShownComercialOfferList(shownOffers);
        if (bottomArrowDisabled) setBottomArrowDisabled(false);
        setTopArrowDisabled(true);
      }
      if (firstOfferIndex === 0) setTopArrowDisabled(true);
    }
  };

  const handleBottomArrow = () => {
    if (
      !bottomArrowDisabled &&
      commercialOffersFilteredList &&
      shownCommercialOfferList &&
      commercialOffersFilteredList.length > 3
    ) {
      const lastOfferIndex = commercialOffersFilteredList.indexOf(
        shownCommercialOfferList?.slice(-1)[0]
      );
      const lastIndexInArray = commercialOffersFilteredList.length - 1;
      const newFirstOfferIndex = lastOfferIndex + 1;
      // Comprueba si en las siguientes 3 posiciones hay elementos. Si no, muestra hasta el final del array
      const newLastOfferIndex = commercialOffersFilteredList[lastOfferIndex + 3] ? lastOfferIndex + 3 : lastIndexInArray;

      if (newFirstOfferIndex <= lastIndexInArray) {
        const shownOffers = commercialOffersFilteredList.slice(
          newFirstOfferIndex,
          newLastOfferIndex + 1,
        );
        setShownComercialOfferList(shownOffers);
        if (topArrowDisabled) setTopArrowDisabled(false);
        if (newLastOfferIndex === lastIndexInArray) setBottomArrowDisabled(true);
      }
    }
  };

  useEffect(() => {
    if (amountError) {
      setInputAmount('');
    }
  }, [amountError]);

  return (
    <>
      {(!simulationSelected || !showSummary || amountError) && (
        <Formik
          initialValues={
            productValue || { product: '', amount: '', termNumber: '0' }
          }
          onSubmit={formSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            submitForm,
            handleChange,
            handleBlur,
          }) => (
            <EntryForm
              name="simulationForm"
              $opacity={startTransition && !amountError ? 0 : 1}
            >
              <div>
                <ProdTitle id="entry-amount-title">
                  Introduce el producto y el importe para simular la
                  financiación
                </ProdTitle>

                <FormInputRow>
                  <FormFloating>
                    <FormInput
                      id="entry-product-input"
                      component="select"
                      name="product"
                      key="product"
                      onBlur={() => {
                        saveProductSelected(values.product);
                      }}
                    >
                      {products?.map((product: GoodTypes) => {
                        return (
                          <FormOption key={product.code} value={product.code}>
                            {product.name}
                          </FormOption>
                        );
                      })}
                    </FormInput>
                    <FormInputLabel htmlFor="product">Producto</FormInputLabel>
                  </FormFloating>
                </FormInputRow>
                <FormInputRow $minHeight="76px">
                  <FormFloating
                    $halfWidth={
                      termList && termList.length > 0 && !hideTermList
                        ? 'true'
                        : ''
                    }
                  >
                    <FormInput
                      id="entry-amount-input"
                      autoComplete="off"
                      type="number"
                      step="any"
                      name="amount"
                      min="0"
                      onKeyDown={blockCharacters}
                      error={
                        amountError || (errors.amount && touched.amount)
                          ? 'true'
                          : ''
                      }
                      validate={validateAmount}
                      onKeyUp={(e: any) => {
                        if (values.amount !== inputAmount) {
                          if (values.amount && e.which !== 13) {
                            setHideTermList(true);
                            setAmountError(false);
                            submitForm();
                          } else if (e.which !== 13) {
                            setAmountError(true);
                            setStartTransition(false);
                            setInputAmount('');
                          }
                        }
                      }}
                      position={
                        termList && termList.length > 0 ? 'left' : 'upper'
                      }
                      onKeyPress={(e: any) => {
                        if (e.which === 13) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e: any) => {
                        handleAmountInput(e, handleChange);
                      }}
                      readOnly={amountParam && inputMode === 'customer_blocked'}
                      $isDisabled={
                        amountParam && inputMode === 'customer_blocked'
                      }
                    />
                    <FormInputLabel
                      htmlFor="amount"
                      $error={
                        amountError || (errors.amount && touched.amount)
                          ? 'true'
                          : ''
                      }
                    >
                      Importe
                    </FormInputLabel>
                    <EuroIcon
                      src={EuroImg}
                      $isDisabled={
                        amountParam && inputMode === 'customer_blocked'
                      }
                    ></EuroIcon>
                    {((amountError && touched.amount) ||
                      (errors.amount && touched.amount)) && (
                      <ValidationError>
                        {amountError ? 'Introduce otro importe' : errors.amount}
                      </ValidationError>
                    )}
                  </FormFloating>
                  {termList && termList.length > 0 && !hideTermList && (
                    <FormFloating $halfWidth="true">
                      <FormInput
                        id="entry-term-input"
                        as="select"
                        name="termNumber"
                        defaultValue={
                          origin && origin === 'personalData' && productValue
                            ? productValue.termNumber
                            : term
                        }
                        onChange={(e: any) => {
                          setTerm(parseInt(e.target.value));
                          setTermError(false);
                        }}
                        className={`${termError && 'error'}`}
                      >
                        {termList &&
                          termList.map((t) => {
                            return (
                              <FormOption value={t.toString()} key={t}>
                                {t}
                              </FormOption>
                            );
                          })}
                        <FormOption value="0" hidden></FormOption>
                      </FormInput>
                      <FormInputLabel
                        htmlFor="term"
                        $error={termError ? 'true' : ''}
                      >
                        Plazo
                      </FormInputLabel>
                      <MonthText>meses</MonthText>
                    </FormFloating>
                  )}
                </FormInputRow>
              </div>
              <ImageEntry
                src={entryShop}
                $opacity={startTransition && amountError ? 0 : 1}
                $addedMargin={showBtn ? '' : '20px auto auto'}
              />
              <MainButton
                id="entry-continue-btn"
                type="button"
                $isHidden={showBtn ? '' : 'true'}
                onClick={async () => {
                  if (values.amount && term) {
                    if (
                      simulatedData?.term !== term ||
                      simulatedData?.amount !== parseFloat(inputAmount)
                    ) {
                      await getLoanSimulation();
                    }
                    if (!amountError) {
                      setShowSummary(true);
                    }
                  } else if (!term) {
                    setTermError(true);
                  }
                }}
              >
                Continuar
              </MainButton>
            </EntryForm>
          )}
        </Formik>
      )}
      {simulationSelected && showSummary && !amountError && (
        <>
          <ProdTitle id="entry-summary-title">
            Introduce los datos para simular la financiación.
          </ProdTitle>
          <SummaryWrapper>
            <SummaryData>
              <TextMedium $fontSize={12}>Importe solicitado</TextMedium>
              <TextBoldSpan $fontSize={12}>
                {transformAmount(amount)} €
              </TextBoldSpan>
              <TextMedium $fontSize={12}>Plazo</TextMedium>
              <TextBoldSpan $fontSize={12}>{term} meses</TextBoldSpan>
            </SummaryData>
            <EditIcon src={editIcon} onClick={handleAmountChange}></EditIcon>
          </SummaryWrapper>
          <OfferSelectorWrapper>
            <Title>Selecciona la tarifa</Title>
            <ArrowWrapper
              onClick={() => handleTopArrow()}
              $isDisabled={topArrowDisabled}
            >
              <ArrowImg direction="up" src={arrowIcon} />
            </ArrowWrapper>
            <RateListWrapper id="offer-list">
              {shownCommercialOfferList?.map((offer: CommercialOfferType) => {
                return (
                  <RateData
                    key={offer.commercial_offer_id}
                    $isSelected={
                      commercialOfferSelected?.commercial_offer_id ===
                      offer.commercial_offer_id
                    }
                    onClick={() => {
                      AnalyticsService.changeSimulation();
                      setcommercialOfferSelected(offer);
                      setSimulationSelected(offer.financial_offers[0]);
                    }}
                  >
                    <RateText>{offer.commercial_offer_name}</RateText>
                    <RateIconWrapper>
                      <ImageIconBank
                        src={offer.flow === 'CEX' ? creditCard : bankCard}
                      />
                    </RateIconWrapper>
                  </RateData>
                );
              })}
            </RateListWrapper>
            <ArrowWrapper
              onClick={() => handleBottomArrow()}
              $isDisabled={bottomArrowDisabled}
            >
              <ArrowImg src={arrowIcon} />
            </ArrowWrapper>
          </OfferSelectorWrapper>
          <WrapperBox>
            <WrapperBoxSection>
              <WrapperBoxElement>
                <TodayHighlight>
                  <TodayHighlightText>
                    {commercialOfferSelected?.flow === 'CEX'
                      ? 'Hoy'
                      : dayjs(
                          commercialOfferSelected?.first_due_date,
                          'YYYY-MM-DD'
                        ).format('DD/MM/YYYY')}
                  </TodayHighlightText>
                </TodayHighlight>
                <FirstFeeText>Primer pago</FirstFeeText>
              </WrapperBoxElement>
              <FirstFee>
                {transformAmount(simulationSelected.first_fee)}€
              </FirstFee>
            </WrapperBoxSection>
            <SeparationLine />
            <WrapperBoxSection>
              <WrapperBoxElement>
                <RegularFeeText>Cuotas restantes ({term - 1})</RegularFeeText>
              </WrapperBoxElement>
              <WrapperBoxElement>
                <RegularFeeText>
                  {transformAmount(simulationSelected.regular_fee)}€ /mes
                </RegularFeeText>
              </WrapperBoxElement>
            </WrapperBoxSection>
          </WrapperBox>
          <WrapperBoxSection>
            {!isDecathlon && (
              <DetailsSectionSubtitle>
                Com. Apertura {transformAmount(simulationSelected.opening_fee)}€
                {simulationSelected.opening_fee !== 0 && (
                  <DetailsSectionSubtitle>
                    {simulationSelected.opening_fee_type === 'F'
                      ? ' financiada'
                      : ' primera cuota'}
                    {simulationSelected.opening_fee_type === 'F' &&
                      ` (${transformAmount(
                        simulationSelected.opening_fee / simulationSelected.term
                      )} € por recibo)`}
                  </DetailsSectionSubtitle>
                )}
              </DetailsSectionSubtitle>
            )}
            {isDecathlon && (
              <DetailSpecialSection id="detail-special-section">
                <DetailsInfo>
                  <TextRegular $fontSize={10}>
                    TIN {transformAmount(simulationSelected.tin)}% | TAE{' '}
                    {transformAmount(simulationSelected.tae)}% | CA{' '}
                    {transformAmount(simulationSelected.opening_fee)}€
                  </TextRegular>
                </DetailsInfo>
                <DetailsInfo>
                  <TextBoldSpan $fontSize={10}>
                    Coste cliente{' '}
                    {transformAmount(
                      simulationSelected.total_cost -
                        simulationSelected.financed_amount
                    )}
                    €
                  </TextBoldSpan>
                </DetailsInfo>
              </DetailSpecialSection>
            )}
          </WrapperBoxSection>
        </>
      )}

      <MainButton
        id="entry-continue-btn"
        onClick={handleContinue}
        $isHidden={
          simulationSelected && !amountError && showSummary ? '' : 'true'
        }
      >
        Continuar
      </MainButton>
    </>
  );
};
